
import React from 'react';
import { motion } from 'framer-motion';

type PaymentStatusType = 'success' | 'pending' | 'failed';

interface PaymentStatusProps {
  status: PaymentStatusType;
  className?: string;
}

const PaymentStatus: React.FC<PaymentStatusProps> = ({ status, className = '' }) => {
  const statusConfig = {
    success: {
      bgColor: 'bg-green-100',
      iconColor: 'text-green-500',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
        </svg>
      ),
      text: 'Payment Successful'
    },
    pending: {
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-500',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      ),
      text: 'Payment Pending'
    },
    failed: {
      bgColor: 'bg-red-100',
      iconColor: 'text-red-500',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      ),
      text: 'Payment Failed'
    }
  };

  const { bgColor, iconColor, icon, text } = statusConfig[status];

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`flex items-center space-x-2 ${className}`}
    >
      <div className={`w-8 h-8 rounded-full ${bgColor} flex items-center justify-center ${iconColor}`}>
        {icon}
      </div>
      <span className="font-medium">{text}</span>
    </motion.div>
  );
};

export default PaymentStatus;
